import { DropDownList } from "@progress/kendo-react-dropdowns";

function DropDownCell({ dataItem, field, dropdownProps = {} }) {
    const fieldArray = field.split('.');

    if (dataItem.selected) {
        return (
            <td>
                <DropDownList {...dropdownProps} />
            </td>
        )
    }

    const value = dataItem[fieldArray[0]] && dataItem[fieldArray[0]][fieldArray[1]] ? dataItem[fieldArray[0]][fieldArray[1]] : '';

    return (
        <td>
            {value}
        </td>
    )

}

export default DropDownCell;